import { safeLocalStorage } from "./safeLocalStorage";

export const SENTRY_ANON_ID_KEY = "sentry_anon_id";

const SENTRY_ID_LENGTH = 32;
const HEX_ID_RE = /^[0-9a-f]{32}$/;

const generateId = (): string => {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID().replace(/-/g, "");
  }

  let id = "";
  for (let i = 0; i < SENTRY_ID_LENGTH; i++) {
    id += Math.floor(Math.random() * 16).toString(16);
  }
  return id;
};

export const getSentryAnonId = (): string => {
  try {
    const existing = safeLocalStorage.getItem(SENTRY_ANON_ID_KEY);
    if (existing && HEX_ID_RE.test(existing)) return existing;

    const id = generateId();
    safeLocalStorage.setItem(SENTRY_ANON_ID_KEY, id);
    return id;
  } catch {
    return generateId();
  }
};

export const clearSentryAnonId = (): void => {
  safeLocalStorage.removeItem(SENTRY_ANON_ID_KEY);
};
